import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// 404
const Page404 = () => import('@/views/pages/Page404');

// Users
const Users = () => import('@/views/users/Index');
const User = () => import('@/views/users/Show');
const UserCreate = () => import('@/views/users/Create');

// Campaign Actions
const CampaignActions = () => import('@/views/campaign-actions/Index');
const CampaignAction = () => import('@/views/campaign-actions/Show');
const CampaignActionCreate = () => import('@/views/campaign-actions/Create');

// News
const NewsArticles = () => import('@/views/news-articles/Index');
const NewsArticle = () => import('@/views/news-articles/Show');
const NewsArticleCreate = () => import('@/views/news-articles/Create');

// Chili Templates
const ChiliTemplates = () => import('@/views/chili-templates/Index');
const ChiliTemplate = () => import('@/views/chili-templates/Show');
const ChiliTemplateCreate = () => import('@/views/chili-templates/Create');

// Downloads
const Downloads = () => import('@/views/downloads/Index');
const Download = () => import('@/views/downloads/Show');
const DownloadCreate = () => import('@/views/downloads/Create');

// Contacts
const Contacts = () => import('@/views/contacts/Index');
const Contact = () => import('@/views/contacts/Show');
const ContactCreate = () => import('@/views/contacts/Create');

// Voting Goals
const VotingGoals = () => import('@/views/voting-goals/Index');
const VotingGoal = () => import('@/views/voting-goals/Show');

// Campaign Actions
const Questionnaires = () => import('@/views/questionnaires/Index');
const Questionnaire = () => import('@/views/questionnaires/Show');
const QuestionnaireCreate = () => import('@/views/questionnaires/Create');

// Cheating letter
const CheatingLetter = () => import('@/views/cheating-letter/Show');

// Tips And Tricks
const TipsAndTricks = () => import('@/views/tips-and-tricks/Show');

// Profile
const Profile = () => import('@/views/profile/Show');

// Statistics
const Statistics = () => import('@/views/statistics/Index');

// Login
const Login = () => import('@/views/login/Login');
const PasswordForgot = () => import('@/views/login/PasswordForgot');
const PasswordReset = () => import('@/views/login/PasswordReset');
const ActivateAccount = () => import('@/views/login/ActivateAccount');

const Dashboard = () => import('@/views/pages/Dashboard');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/admin',
      name: 'admin',
      redirect: 'admin/dashboard',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        {
          path: 'users',
          name: 'users',
          component: Users
        },
        {
          path: 'users/toevoegen',
          name: 'users.create',
          component: UserCreate
        },
        {
          path: 'users/:id',
          name: 'users.view',
          component: User
        },
        {
          path: 'campaign-actions',
          name: 'campaign-actions',
          component: CampaignActions
        },
        {
          path: 'campaign-actions/toevoegen',
          name: 'campaign-actions.create',
          component: CampaignActionCreate
        },
        {
          path: 'campaign-actions/:id',
          name: 'campaign-actions.view',
          component: CampaignAction
        },
        {
          path: 'news-articles',
          name: 'news-articles',
          component: NewsArticles
        },
        {
          path: 'news-articles/toevoegen',
          name: 'news-articles.create',
          component: NewsArticleCreate
        },
        {
          path: 'news-articles/:id',
          name: 'news-articles.view',
          component: NewsArticle
        },
        {
          path: 'chili-templates',
          name: 'chili-templates',
          component: ChiliTemplates
        },
        {
          path: 'chili-templates/toevoegen',
          name: 'chili-templates.create',
          component: ChiliTemplateCreate
        },
        {
          path: 'chili-templates/:id',
          name: 'chili-templates.view',
          component: ChiliTemplate
        },
        {
          path: 'downloads',
          name: 'downloads',
          component: Downloads
        },
        {
          path: 'downloads/toevoegen',
          name: 'downloads.create',
          component: DownloadCreate
        },
        {
          path: 'downloads/:id',
          name: 'downloads.view',
          component: Download
        },
        {
          path: 'contacts',
          name: 'contacts',
          component: Contacts
        },
        {
          path: 'contacts/toevoegen',
          name: 'contacts.create',
          component: ContactCreate
        },
        {
          path: 'contacts/:id',
          name: 'contacts.view',
          component: Contact
        },
        {
          path: 'voting-goals',
          name: 'voting-goals',
          component: VotingGoals
        },
        {
          path: 'voting-goals/:id',
          name: 'voting-goals.view',
          component: VotingGoal
        },
        {
          path: 'questionnaires',
          name: 'questionnaires',
          component: Questionnaires
        },
        {
          path: 'questionnaires/toevoegen',
          name: 'questionnaires.create',
          component: QuestionnaireCreate
        },
        {
          path: 'questionnaires/:id',
          name: 'questionnaires.view',
          component: Questionnaire
        },
        {
          path: 'cheating-letter',
          name: 'cheating-letter.view',
          component: CheatingLetter,
        },
        {
          path: 'tips-and-tricks',
          name: 'tips-and-tricks.view',
          component: TipsAndTricks,
        },
        {
          path: 'statistics',
          name: 'statistics',
          component: Statistics
        },
      ],
    },
    {
      path: '/',
      name: 'login-main',
      redirect: '/login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: PasswordForgot
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: PasswordReset
        },
        {
          path: 'activate-account',
          name: 'activate-account',
          component: ActivateAccount
        }
      ]
    },
    {
      path: '*',
      component: Page404
    },
  ]
});

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  if (to.fullPath.includes('/admin')) {
    if (!store.state.accessToken) {
      next('/login');
    }
  }
  if (to.fullPath === '/login') {
    if (store.state.accessToken) {
      next('/admin/dashboard');
    }
  }
  next();
});

export default router;
